import configService, { Config } from "@/api/config.service";
import { computed, ref } from "@vue/runtime-core";
import { defineStore } from "pinia";

export const useConfigStore = defineStore("config", () => {
  const agcoConfig = ref<Config | null>(null);
  const loading = ref(false);
  const error = ref<string | null>(null);

  // Computed pour vérifier si l'app est bloquée
  const isAppLocked = computed(() => agcoConfig.value?.app_locked ?? false);
  const appLockedMessage = computed(
    () =>
      agcoConfig.value?.app_locked_message ??
      "L'application est temporairement indisponible pour maintenance."
  );

  async function fetchAgcoConfig() {
    loading.value = true;
    error.value = null;
    try {
      agcoConfig.value = await configService.getAgcoConfig();
    } catch (err) {
      error.value = "Erreur lors de la récupération de la configuration AGCO";
      console.error(err);
    } finally {
      loading.value = false;
    }
  }

  return {
    agcoConfig,
    loading,
    error,
    isAppLocked,
    appLockedMessage,
    fetchAgcoConfig,
  };
});
